var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreaterred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.14906 4.05L9.08407 9.015L4.14906 13.95H0.414062V18H5.82906L14.8291 9.015L5.82906 0H0.414062V4.05H4.14906Z",
    fill: "#FF5100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterred);
export default __webpack_public_path__ + "static/media/greaterred.d10e3705197125a52cc08655c3d86bbb.svg";
export { ForwardRef as ReactComponent };